import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/home/Hero";
import { Services } from "@/components/home/Services";
import { WhyBrokerage } from "@/components/home/WhyBrokerage";
import { RackTypes } from "@/components/home/RackTypes";
import { LocationsTeaser } from "@/components/home/LocationsTeaser";
import { CTASection } from "@/components/home/CTASection";
import { usePageMeta } from "@/hooks/use-page-meta";
import { OrganizationSchema } from "@/components/seo/OrganizationSchema";

const Index = () => {
  usePageMeta({
    title: "Pallet Racking USA | Nationwide Warehouse Racking Broker",
    description: "PalletRackingUSA connects warehouse managers with quality pallet racking systems—new and used—from vetted manufacturers across North America. Get quotes in 24 hours.",
  });
  return (
    <div className="min-h-screen flex flex-col">
      <OrganizationSchema />
      <Header />
      <main id="main-content" className="flex-1">
        <Hero />
        <Services />
        <WhyBrokerage />
        <RackTypes />
        <LocationsTeaser />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
